import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../api/client.js";
import type { ServiceCategory } from "../rfqs/api.js";

export interface ContractorProfile {
  id: string;
  businessName: string;
  contactName: string;
  phone: string;
  email: string;
  website?: string;
  serviceCategories: ServiceCategory[];
  serviceArea: string;
  yearsExperience: number;
  licenseInfo?: string;
  insuranceInfo?: string;
  about?: string;
  notes?: string;
  createdAt: string;
}

export interface CreateContractorProfileInput {
  businessName: string;
  contactName: string;
  phone: string;
  email: string;
  website?: string;
  serviceCategories: ServiceCategory[];
  serviceArea: string;
  yearsExperience: number;
  licenseInfo?: string;
  insuranceInfo?: string;
  about?: string;
  notes?: string;
}

const QK = {
  list: ["contractor-profiles"] as const,
};

export function useCreateContractorProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateContractorProfileInput) =>
      apiFetch<ContractorProfile>("/public/contractor-profiles", {
        method: "POST",
        json: input,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: QK.list });
    },
  });
}

export function useContractorProfilesList() {
  return useQuery({
    queryKey: QK.list,
    queryFn: async () => {
      const res = await apiFetch<{ items: ContractorProfile[] }>("/public/contractor-profiles");
      return res.items;
    },
  });
}
